import { AERIALS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core/api';
import { handleQueryLifecycle } from '../utils';
import type { AerialMutationPayload, AerialMutationResponse } from './types';

export const CREATE_AERIAL_URL = 'aerial/create';

export type CreateAerialPayload = AerialMutationPayload;
export type CreateAerialResponse = AerialMutationResponse;

const createAerialApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCreateAerial: builder.mutation<CreateAerialResponse, CreateAerialPayload>({
      query: (body) => ({
        url: CREATE_AERIAL_URL,
        method: 'POST',
        body,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          dispatch(api.util.invalidateTags([AERIALS_LIST_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostCreateAerialMutation } = createAerialApi;
